import { post } from '@chat/utils';
import { FAQ_REPORT } from '@/api/url';

/**
 * 超时统计上报工具函数
 * @param faq_unique_id - FAQ唯一标识
 * @param encrypt - 加密函数
 * @param isSuccess - 是否成功，默认为 false
 */
export const reportTimeout = async (
    faq_unique_id: string,
    encrypt: (data: string) => string | false,
    isSuccess = false
): Promise<void> => {
    try {
        const encryptedData = encrypt(`${faq_unique_id}|${Date.now()}|${isSuccess}`);
        if (!encryptedData) {
            console.debug('超时统计上报失败: 加密失败');
            return;
        }

        await post(FAQ_REPORT, {
            data: encryptedData
        });
    } catch (e) {
        // 静默处理上报失败，不影响业务逻辑
        console.debug('超时统计上报失败:', e);
    }
};

export default reportTimeout;
